import React, { Component } from 'react';
import {connect} from 'react-redux';
import AvailableDriversListView from './available-drivers-list-view';
import { getAvailableDrivers } from '../available-drivers/available-drivers-actions';

class AvailableDriversList extends Component {

  componentDidMount() {
    this.props.getAvailableDrivers()
  }

  render() {
    return (
      <AvailableDriversListView
        {...this.props}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  availableDrivers: state.availableDrivers
});

const mapDispatchToProps = {
  getAvailableDrivers: getAvailableDrivers
};

export default connect(mapStateToProps, mapDispatchToProps)(AvailableDriversList);



// WEBPACK FOOTER //
// ./src/components/available-drivers-list/available-drivers-list.js